import classNames from "classnames";
import { type ComponentPropsWithoutRef, type ElementType } from "react";
import { useTranslation } from "react-i18next";
import { isTariffSurchargeEnabled } from "~/feature/cart/cart/utils/cartUtils";

interface Props<T extends ElementType> {
  as?: T;
  hasSurcharge?: boolean;
  tariffSurcharge?: boolean;
}

export function IncludesSurchargeDisclaimer<T extends ElementType = "div">({
  as,
  className,
  hasSurcharge = false,
  tariffSurcharge = false,
  ...rest
}: Props<T> & Omit<ComponentPropsWithoutRef<T>, keyof Props<T>>) {
  const { t } = useTranslation();
  const Tag = as ?? "div";

  // If neither flag is true, render nothing
  if (!tariffSurcharge && !hasSurcharge) {
    return null;
  }

  // Priority: tariffSurcharge > hasSurcharge
  const textKey =
    tariffSurcharge && isTariffSurchargeEnabled() ? "price.tariff.surcharge.apply" : "price.includesSurcharge";

  return (
    <Tag className={classNames(className, "f-label-color")} {...rest}>
      {t(textKey)}
    </Tag>
  );
}
